import React from 'react';

import type { FetchProductsQueryResponse } from '../../../../../../main/products/queries/fetchProducts.query';
import { IconsEnum } from '../../../../../../assets/icons/types';
import { PrimaryNavTabsEnum } from '../../../../../hooks/useMenu/types';

import { FETCH_PRODUCTS_QUERY } from '../../../../../../main/products/queries/fetchProducts.query';
import { CACHE_FETCH_PRODUCTS_QUERY } from '../../../../../../main/products/queries/fetchCacheProducts.query';

import { useCurrentUser } from '../../../../../../auth/hooks/useAuth';
import { useCacheProducts } from '../../../../../../main/products/hooks/useCacheProducts';

import { PrimaryNavTooltipMenuWithSectionsTab } from '../PrimaryNavTooltipMenuWithSectionsTab';

import { menuKeys } from '../../../../../../locales/keys';
import { newStockMenuLinks } from '../../../../../../main/common/components/menus/CompactStockSecondaryMenu/compactStockSecondaryMenuConstants';
import { selfCompanyNewLibraryMenuLinks } from '../../../../../../main/common/components/menus/CompactCompanyLibraryMenu/compactCompanyLibraryMenuConstants';

import { ProductCache } from '../../../../../../main/products/ProductCache';
import { StockPath } from '../../../../../../main/stock/StockPath';
import { TeamPath } from '../../../../../../main/teams/TeamPath';

const initialLimit = 1;

function PrimaryNavLibraryTab() {
  const currentUser = useCurrentUser();

  const { products } = useCacheProducts<FetchProductsQueryResponse>({
    cacheKey: ProductCache.currentCompanyLibraryCacheKey(),
    cacheQuery: CACHE_FETCH_PRODUCTS_QUERY,
    initialFilters: {
      teamIds: [currentUser?.currentTeam?.uuid],
      blocked: false
    },
    initialLimit,
    query: FETCH_PRODUCTS_QUERY,
    options: {
      enabled: !!currentUser?.currentTeam?.uuid,
      enabledPlaceholder: false,
      staleTime: 1000 * 60 * 60,
      withoutPrefetch: true,
      keepPreviousData: true
    }
  });

  return (
    <PrimaryNavTooltipMenuWithSectionsTab
      addClassName="three-d-stock-menu-tour"
      href={
        products?.length > 0
          ? TeamPath.currentCompanyNewLibraryProducts()
          : StockPath.newProducts()
      }
      icon={IconsEnum.CUBES_OUTLINE}
      tab={PrimaryNavTabsEnum.NEW_STOCK}
      onlyHref={products?.length > 0}
      sections={[
        {
          sectionI18nText: menuKeys.tabs.stock3d,
          links: newStockMenuLinks
        },
        {
          sectionI18nText: menuKeys.tabs.myLibrary,
          links: selfCompanyNewLibraryMenuLinks
        }
      ]}
    />
  );
}

export default PrimaryNavLibraryTab;
